import { memo } from "react"
import { useSelector } from "react-redux"

import {
  othersSnippets,
  pinnedSnippets,
  snippetsTabsValue,
} from "rtk-slice"

import {
  Divider,
  Stack,
  styled,
  Typography,
  useTheme,
} from "@mui/material"

import { Cross, HomeColors, Shrug } from "ui-icons"

import MainMasonry from "./MainMasonry"

const Root = styled("div")(({ theme }) => ({
  marginBottom: "3em",
  paddingTop: "2em",
  ...theme.typography.body1,
}))

const SnippetsContainer = () => {
  const {
    palette: {
      primary: { main },
    },
  } = useTheme()
  const othersSnippetsLengthState = useSelector(othersSnippets).length
  const pinnedSnippetsLengthState = useSelector(pinnedSnippets).length
  const snippetsTabsValueState = useSelector(snippetsTabsValue)

  return (
    <Root>
      <MainMasonry />
      {(!pinnedSnippetsLengthState && !snippetsTabsValueState) ||
      (!othersSnippetsLengthState && snippetsTabsValueState) ? (
        <Stack alignItems="center">
          <Shrug />
          <Typography
            textAlign="center"
            variant="h5"
            component="span"
            textTransform="uppercase"
          >
            There{"'"}s no any snippets.
          </Typography>
          <Typography
            textAlign="center"
            variant="body1"
            component="span"
          >
            Change filter criteria.
          </Typography>
          <Typography
            textAlign="center"
            variant="body1"
            component="span"
          >
            Toggle between PINNED & OTHERS Tabs.
          </Typography>
          <Typography
            textAlign="center"
            variant="body1"
            component="span"
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "0.5em",
            }}
          >
            Click on <HomeColors width="20" height="20" /> to go to
            Desktop.
          </Typography>
          <Divider
            textAlign="center"
            sx={{ mb: "2em", width: "30%", m: "0 auto" }}
          >
            <Typography
              textAlign="center"
              variant="body1"
              component="span"
            >
              Or
            </Typography>
          </Divider>
          <Typography
            textAlign="center"
            variant="body1"
            component="span"
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "0.5em",
            }}
          >
            Click on <Cross fill={main} width="20" height="20" /> to
            add new snippet.
          </Typography>
        </Stack>
      ) : null}
    </Root>
  )
}

export default memo(SnippetsContainer)
